<template>

    <div>
    </div>

</template>


<script>
//    import LngChooser from '@/components/LngChooser.vue';
//    import AlertInPage from '@/components/AlertInPage.vue';
//    import Helper from '@/helper/Helper';
//    import InputText from '@/components/InputText.vue';
//    import InvHeader from "../components/InvHeader";
//    const moment = require('moment');

    export default {
        name: 'EmptyPage',
//        roles: [1, 2, 3, 7, 8, 9],
        data() {
            return {
//                prefix: "",
//                suffix: "",
//                data: {}
//                , AlertInPage: {
//                    type: "", // primary secondary success danger warning info light dark
//                    msg: "",
//                    delay: 5000,
//                }
            };
        },
        watch: {},
        mounted() {

//            const modul = this;
//            console.log(this.$route.name + " mounded");
//            modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
//            if (!Helper.checkRoles(modul.roles)) {
//                modul.$router.push({name: "login"})
//            }
//            modul.helper = Helper;
//            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
//            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
//            setTimeout(function () {
//                if (modul.$route && modul.$route.name && modul.$route.name === "emptypage") {
//                    modul.$router.push({name: "invoices"});
//                }
//            }, 1000)
        },
        beforeDestroy() {
//            const modul = this;
        },
        methods: {},
        components: {
//            InvHeader,
//            LngChooser,
//            AlertInPage,
        },
    };
</script>
